import { jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraInlineBanner } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { KIND_TO_PROTO } from '../../../components/SharedRecord/registryResolveClient';
import { registryKeys } from '../queryKeys';
import { registryRecordClient } from '../records/registryRecordClient';
/** "{loser} was merged into this record on {date}." on the survivor reached via ?mergedFrom=. */ export function MergedRecordBanner({ kind, survivorId }) {
    const [params] = useSearchParams();
    const mergedFrom = params.get('mergedFrom');
    const events = useQuery({
        queryKey: registryKeys.mergeEvents(kind, survivorId),
        enabled: !!mergedFrom,
        retry: false,
        queryFn: async ()=>(await registryRecordClient.listRegistryMergeEvents({
                kind: KIND_TO_PROTO[kind],
                registryId: survivorId
            })).events
    });
    const event = events.data?.find((e)=>!e.reversedAt && e.loser?.id === mergedFrom && e.survivor?.id === survivorId);
    if (!event) return null;
    const when = event.createdAt?.toDate().toLocaleDateString();
    return /*#__PURE__*/ _jsxs(SpecraInlineBanner, {
        tone: "info",
        "data-testid": Testids.registryMerge.mergedBanner,
        children: [
            event.loser?.name || 'A record',
            " was merged into this record",
            when ? ` on ${when}` : '',
            "."
        ]
    });
}
